<script lang="ts">
  export let autoclose = true

  let show = false
  let dropdown: HTMLDivElement

  function handleOutsideClick(e: Event) {
    if (show && !dropdown.contains(e.target as HTMLElement)) close()
  }

  function handleEscape(e: KeyboardEvent) {
    if (show && e.key === 'Escape') show = false
  }

  function toggle(e: Event) {
    e.preventDefault()
    show = !show
  }

  function close() {
    show = false
  }

  function toggleMenu(e: Event) {
    const menu = dropdown?.querySelector('.menu')

    if (menu && menu.contains(e.currentTarget as HTMLElement)) {
      if (autoclose) {
        close()
      }
      return
    }

    show = !show
  }
</script>

<svelte:body onclick={handleOutsideClick} onkeyup={handleEscape}/>

{#if $$slots.prefix}
  <div bind:this={dropdown} class="prefix-wrapper">
    <slot name="prefix" {toggle}/>
    <div class={$$props.class ?? 'ui dropdown select'} onclick={toggleMenu}>
      <slot {show} {toggle} {close}/>
    </div>
  </div>
{:else}
  <div class={$$props.class ?? 'ui dropdown select'} bind:this={dropdown} onclick={toggleMenu}>
    <slot {show} {toggle} {close}/>
  </div>
{/if}

<style>
  .prefix-wrapper {
    display: inline-block;
  }
</style>